console.log('[Home Script] script.home.js loaded');

document.addEventListener('DOMContentLoaded', function() {
    console.log('[Home Script] DOMContentLoaded event fired');
    // Check for order success redirect
    const isRedirectOrderSuccess = localStorage.getItem('isRedirectOrderSuccess');
    if (isRedirectOrderSuccess) {
        // Remove the flag from localStorage
        localStorage.removeItem('isRedirectOrderSuccess');
        // 注文完了ページは、決済後にここから移ってきたことを確かめてから計測とカートの片付けをするので、印を渡す
        try {
            sessionStorage.setItem('orderSuccessRedirect', '1');
        } catch (e) {
            // 保存できないときも遷移は続ける（同じタブで決済へ進んでいれば、注文完了ページは退避した明細で判断する）
        }
        // Redirect to order success page
        window.location.href = '/pages/order-success';
        return; // Stop execution to prevent other code from running
    }

    // 決済後の目印が無いままトップへ来たタブ（決済画面のロゴから戻った、など）は、決済をやめている。
    // 注文完了ページが証拠と取り違えないよう、決済へ進んだ印（checkout_started_at）だけを消し、明細は残す
    try {
        const pendingOrder = JSON.parse(sessionStorage.getItem('posthog_pending_order') || 'null');
        if (pendingOrder && pendingOrder.checkout_started_at != null) {
            const pendingItems = Array.isArray(pendingOrder.items) ? pendingOrder.items : [];
            sessionStorage.setItem('posthog_pending_order', JSON.stringify({ items: pendingItems }));
        }
    } catch (e) {
        // sessionStorage が使えない場合は印も付いていないので、何もしない
    }

    const tabButtons = document.querySelectorAll('.tab-button');
    const tabContents = document.querySelectorAll('.tab-content');

    // Set initial active states
    function setActiveTab(activeTab) {
        // Remove active class from all buttons and contents
        tabButtons.forEach(button => {
            button.classList.remove('active');
        });

        tabContents.forEach(content => {
            content.classList.remove('active');
        });

        // Add active class to selected button and content
        const activeButton = document.querySelector(`[data-tab="${activeTab}"]`);
        const activeContent = document.getElementById(`${activeTab}-content`);

        if (activeButton && activeContent) {
            activeButton.classList.add('active');
            activeContent.classList.add('active');
        }
    }

    // Initialize with material tab active
    setActiveTab('material');

    // Add click event listeners to tab buttons
    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            const tabName = this.getAttribute('data-tab');
            setActiveTab(tabName);
        });
    });

    // Add staggered animation to icons
    function animateIcons() {
        const iconElements = document.querySelectorAll('.tab-content.active .icon-item');
        iconElements.forEach((icon, index) => {
            icon.style.opacity = '0';
            icon.style.transform = 'translateY(20px)';
            
            setTimeout(() => {
                icon.style.transition = 'opacity 300ms cubic-bezier(0.4, 0, 0.2, 1), transform 300ms cubic-bezier(0.4, 0, 0.2, 1)';
                icon.style.opacity = '1';
                icon.style.transform = 'translateY(0)';
            }, index * 50);
        });
    }

    // Initial animation
    animateIcons();

    // Re-animate on tab change
    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            setTimeout(animateIcons, 50);
        });
    });


    // Dynamic Calendar functionality
    // Day names in Japanese
    const dayNames = ['日', '月', '火', '水', '木', '金', '土'];
    
    // Month names in Japanese
    const monthNames = [
        '1月', '2月', '3月', '4月', '5月', '6月',
        '7月', '8月', '9月', '10月', '11月', '12月'
    ];
    
    // Get current date
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    let selectedDates = [];

    if (window.storeHoliday && window.storeHoliday.trim() !== "") {
        selectedDates = window.storeHoliday.split(",").map(date => date.trim());
    }

    function generateCalendar(year, month, containerId, headerElementId) {
        const container = document.getElementById(containerId);
        const headerElement = document.getElementById(headerElementId);
        
        if (!container || !headerElement) return;
        
        // Update header with dynamic month/year
        headerElement.textContent = `${year}年${monthNames[month]}`;
        
        // Clear existing content
        container.innerHTML = '';
        
        // Add day headers
        dayNames.forEach(dayName => {
            const dayHeader = document.createElement('div');
            dayHeader.classList.add('calendar-day-header');
            dayHeader.textContent = dayName;
            container.appendChild(dayHeader);
        });
        
        // Get first day of month and number of days (using 0-indexed month)
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();
        const startDay = firstDay.getDay(); // 0 = Sunday, 6 = Saturday
        
        // Get previous month's last days
        const prevMonth = month === 0 ? 11 : month - 1;
        const prevYear = month === 0 ? year - 1 : year;
        const prevMonthLastDay = new Date(prevYear, prevMonth + 1, 0).getDate();
        
        // Add previous month's trailing days
        for (let i = startDay - 1; i >= 0; i--) {
            const dayElement = document.createElement('div');
            dayElement.classList.add('calendar-day', 'other-month');
            dayElement.textContent = prevMonthLastDay - i;
            container.appendChild(dayElement);
        }
        
        // Add current month days
        for (let day = 1; day <= daysInMonth; day++) {
            const dayElement = document.createElement('div');
            dayElement.classList.add('calendar-day');
            dayElement.textContent = day;
            
            // Check if it's today
            const currentDate = new Date(year, month, day);
            const todayDate = new Date();
            if (currentDate.toDateString() === todayDate.toDateString()) {
                dayElement.classList.add('today');
            }
            
            // Check if it's weekend (Saturday = 6, Sunday = 0)
            const dayOfWeek = currentDate.getDay();
            if (dayOfWeek === 0 || dayOfWeek === 6) {
                dayElement.classList.add('weekend');
            }
            
            // Check if it's a selected date
            const dateString = `${year}-${(month + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
            if (selectedDates.includes(dateString)) {
                dayElement.classList.add('selected');
            }
            
            container.appendChild(dayElement);
        }
        
        // Fill remaining slots with next month's days
        const totalCells = container.children.length - 7; // Subtract day headers
        const remainingCells = 42 - totalCells; // 6 rows × 7 days = 42 total cells
        
        for (let day = 1; day <= remainingCells && totalCells < 35; day++) {
            const dayElement = document.createElement('div');
            dayElement.classList.add('calendar-day', 'other-month');
            dayElement.textContent = day;
            container.appendChild(dayElement);
        }
    }

    // Calculate the three months to display: current month and next two months
    const months = [];
    for (let i = 0; i < 3; i++) {
        let targetMonth = currentMonth + i;
        let targetYear = currentYear;
        
        // Handle year overflow
        if (targetMonth > 11) {
            targetMonth = targetMonth - 12;
            targetYear = currentYear + 1;
        }
        
        months.push({ year: targetYear, month: targetMonth });
    }
    
    // Generate the three calendars dynamically
    // desktop calendars
    generateCalendar(months[0].year, months[0].month, 'desktop-first-calendar-grid', 'desktop-first-calendar-header');
    generateCalendar(months[1].year, months[1].month, 'desktop-second-calendar-grid', 'desktop-second-calendar-header');
    generateCalendar(months[2].year, months[2].month, 'desktop-third-calendar-grid', 'desktop-third-calendar-header');
    // mobile calendars
    generateCalendar(months[0].year, months[0].month, 'mobile-first-calendar-grid', 'mobile-first-calendar-header');
    generateCalendar(months[1].year, months[1].month, 'mobile-second-calendar-grid', 'mobile-second-calendar-header');
    generateCalendar(months[2].year, months[2].month, 'mobile-third-calendar-grid', 'mobile-third-calendar-header');

    const calendarSlideSwiperEl = document.querySelector('.calendar-slide');
    if (calendarSlideSwiperEl) {
      Object.assign(calendarSlideSwiperEl, {
        slidesPerView: 2,
        spaceBetween: 5,
        breakpoints: {
            320: { slidesPerView: 1, spaceBetween: 10 },
            500: { slidesPerView: 2, spaceBetween: 20 },
            768: { slidesPerView: 2, spaceBetween: 30 },
        },
      });

      calendarSlideSwiperEl.initialize();
    }

    // Order Status API Integration
    const ORDERS_API_ENDPOINT = window.apiUrl + '/api/orders';
    
    async function fetchOrderData() {
        try {            
            const response = await fetch(ORDERS_API_ENDPOINT, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                mode: 'cors'
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            
            // Check if response has success field (following favourites pattern)
            if (data.success === false) {
                throw new Error(data.error || 'API returned error');
            }
            
            return data;
        } catch (error) {
            return null;
        }
    }

    function formatOrderDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        
        return `${year}年${month}月${day}日${hours}:${minutes}`;
    }

    function formatOrderPrice(price) {
        return new Intl.NumberFormat('ja-JP').format(price);
    }

    function renderOrderStatus(orders) {
        const orderStatusContainer = document.querySelector('.order-status-content ul');
        if (!orderStatusContainer) return;

        // Clear existing content
        orderStatusContainer.innerHTML = '';

        if (!orders || orders.length === 0) {
            orderStatusContainer.innerHTML = '<li class="order-status-row">データがありません</li>';
            return;
        }

        // Show latest 10 orders
        const latestOrders = orders.slice(0, 200);
        
        latestOrders.forEach(order => {
            const orderRow = document.createElement('li');
            orderRow.classList.add('order-status-row');
            
            const formattedDate = formatOrderDate(order.created_at);
            const formattedPrice = formatOrderPrice(order.total_price_including_tax);
            const escapedPrice = formattedPrice.replace(/[<>&"']/g, c => ({'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;',"'":"&#39;"}[c]));
            const escapedDate = formattedDate.replace(/[<>&"']/g, c => ({'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;',"'":"&#39;"}[c]));
            orderRow.innerHTML = `<span class="order-date">${escapedDate}</span>${escapedPrice}円のご注文をいただきました。`;
            orderStatusContainer.appendChild(orderRow);
        });
    }

    // Load order data when page loads
    async function loadOrderStatus() {
        const orderStatusContainer = document.querySelector('.order-status-content ul');
        if (!orderStatusContainer) return;

        // Show loading state
        orderStatusContainer.innerHTML = '<li class="order-status-row">読み込み中...</li>';

        const data = await fetchOrderData();
        if (data && data.orders && data.orders.length > 0) {
            renderOrderStatus(data.orders);
        } else {
            // No data or API fail - display empty state
            orderStatusContainer.innerHTML = '<li class="order-status-row">データがありません</li>';
        }
    }

    // Initialize order status
    loadOrderStatus();

    // Initialize Category Banner Swiper
    function initCategoryBannerSwiper() {
        const categoryBannerSwiper = document.querySelector('.category-banner-swiper');
        if (!categoryBannerSwiper) return;
        
        // Get slide count
        const slideCount = categoryBannerSwiper.querySelectorAll('swiper-slide').length;

        // レスポンシブ設定を適用
        const updateSwiperSettings = () => {
            const width = window.innerWidth;
            let slidesPerView = 1;
            let spaceBetween = 10;

            if (width >= 1024) {
                slidesPerView = 3;
                spaceBetween = 20;
            } else if (width >= 768) {
                slidesPerView = 2;
                spaceBetween = 15;
            } else if (width >= 640) {
                slidesPerView = 1;
                spaceBetween = 15;
            }
            
            // ループ有効化の判定（スライド数が表示数より多い場合のみループ）
            // Swiperのループモードは、スライド数がslidesPerViewより多くないと正しく動作しない（警告が出る）
            // 安全のため、スライド数がslidesPerView * 2以上、または少なくともslidesPerView + 1以上であることを推奨
            const enableLoop = slideCount > slidesPerView;

            // Swiper Web Componentに設定を適用
            categoryBannerSwiper.setAttribute('slides-per-view', slidesPerView);
            categoryBannerSwiper.setAttribute('space-between', spaceBetween);
            categoryBannerSwiper.setAttribute('loop', enableLoop.toString());

            // Swiperインスタンスが存在する場合は更新
            if (categoryBannerSwiper.swiper) {
                categoryBannerSwiper.swiper.params.slidesPerView = slidesPerView;
                categoryBannerSwiper.swiper.params.spaceBetween = spaceBetween;
                categoryBannerSwiper.swiper.params.loop = enableLoop;
                
                // タッチ操作を確実に有効化
                categoryBannerSwiper.swiper.params.allowTouchMove = true;
                categoryBannerSwiper.swiper.params.touchRatio = 1;
                categoryBannerSwiper.swiper.params.threshold = 5;
                categoryBannerSwiper.swiper.params.grabCursor = true;
                
                categoryBannerSwiper.swiper.update();
                
                // 初期化完了のクラスを追加
                if (!categoryBannerSwiper.classList.contains('swiper-initialized')) {
                    categoryBannerSwiper.classList.add('swiper-initialized');
                }
            }
        };

        // 初期設定（即座に適用）
        updateSwiperSettings();

        // Swiper初期化を待つ
        const checkSwiperInit = setInterval(() => {
            if (categoryBannerSwiper.swiper) {
                clearInterval(checkSwiperInit);
                updateSwiperSettings();
            }
        }, 50);

        // タイムアウト（最大3秒待つ）
        setTimeout(() => {
            clearInterval(checkSwiperInit);
            if (categoryBannerSwiper.swiper) {
                updateSwiperSettings();
            } else {
                // Swiperが初期化されていない場合でも表示
                categoryBannerSwiper.classList.add('swiper-initialized');
            }
        }, 3000);

        // ウィンドウリサイズ時に再設定
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(updateSwiperSettings, 250);
        });
    }

    // ウィンドウの読み込みが完全に終わってから実行
    if (document.readyState === 'complete') {
        initCategoryBannerSwiper();
    } else {
        window.addEventListener('load', initCategoryBannerSwiper);
    }

    // サイドバー検索機能（ホームページ用）
    console.log('[Home] 検索機能の初期化開始');
    
    const pageSearchInput = document.querySelector('#page-search-input');
    const pageSearchButton = document.querySelector('#page-search-addon');

    console.log('[Home] 検索要素の取得:', {
        input: pageSearchInput,
        button: pageSearchButton,
        inputExists: !!pageSearchInput,
        buttonExists: !!pageSearchButton
    });
    
    // デバッグ用：すべてのinputとbuttonを確認
    console.log('[Home] ページ内のすべての検索関連要素:', {
        allInputs: document.querySelectorAll('input[id*="search"]'),
        allButtons: document.querySelectorAll('button[id*="search"]')
    });

    function handlePageSearch() {
        if (!pageSearchInput) {
            console.error('[Home] 検索入力欄が見つかりません');
            return;
        }
        
        const searchValue = pageSearchInput.value.trim();
        console.log('[Home] 検索実行:', searchValue);
        
        if (searchValue) {
            // 商品一覧ページ（/collections）に検索クエリ付きで遷移
            const params = new URLSearchParams({
                title: searchValue
            });
            const url = `/collections?${params.toString()}`;
            console.log('[Home] リダイレクト先:', url);
            window.location.href = url;
        } else {
            console.log('[Home] 検索語が空のため、リダイレクトしません');
        }
    }

    if (pageSearchButton) {
        pageSearchButton.addEventListener('click', handlePageSearch);
        console.log('[Home] 検索ボタンのイベントリスナーを設定しました');
    } else {
        console.error('[Home] 検索ボタンが見つかりません (#page-search-addon)');
    }

    if (pageSearchInput) {
        pageSearchInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                console.log('[Home] Enterキーで検索実行');
                handlePageSearch();
            }
        });
        console.log('[Home] 検索入力欄のイベントリスナーを設定しました');
    } else {
        console.error('[Home] 検索入力欄が見つかりません (#page-search-input)');
    }
});
